module.exports = __webpack_public_path__ + "img/05.12dc1898.jpg";